import { useEffect } from "react";
import { rangePickerInitialValue } from "../../../../BookingForm/components/utils";

export const useInitializePaymentData = ({
  data,
  onEditBack,
  setValue,
  setPaymentStatusOn,
  setPaymentMode,
  setBankNameFromDropDown,
  bouncedChequeFee,
  orgData,
  visibilityOptions,
  paymentModeOptions,
  bouncedReasons,
  formatString,
}) => {
  useEffect(() => {
    if (!data) return;

    // --- Step 1: Update cheque status based on selectedOption
    switch (data?.selectedOption) {
      case "confirm_payment":
        data.params.data.chequeStatus = "paid";
        break;
      case "transfer_in_progress":
        data.params.data.chequeStatus = "paid";
        break;
      case "mark_as_bounced":
        data.params.data.chequeStatus = "bounce";
        break;
      case "cancelled":
        data.params.data.chequeStatus = "cancelled";
        break;
      case "replace_cheque":
        data.params.data.chequeStatus = "pending";
        break;
      default:
        break;
    }

    const chequeData = data?.params?.data;

    // --- Step 2: Set payment status and related fields
    setPaymentStatusOn(chequeData?.chequeStatus);
    setValue("paymentMethodType", { label: "Full", value: 1 }, { shouldValidate: true });

    if (chequeData?.balance) {
      setValue("amountToPay", chequeData?.balance, { shouldValidate: false });
    }

    if (!chequeData?.balance) {
      setValue("amountToPay", chequeData?.totalAmount, { shouldValidate: false });
    }

    setValue("totalBalance", chequeData?.totalAmount || 0, { shouldValidate: false });
    setValue(
      "depositAccount",
      chequeData?.depositToAccountNumber || chequeData?.beneficiaryAccount || chequeData?.lessorAccountNumber || "",
      { shouldValidate: false }
    );

    setValue("depositTo", {
      label: chequeData?.depositTo,
      value: chequeData?.depositTo,
    });

    setValue(
      "paymentStatus",
      {
        value: chequeData?.chequeStatus,
        label: visibilityOptions.find(
          (option) => option.value?.toLowerCase() === chequeData?.chequeStatus?.toLowerCase()
        )?.label,
      },
      { shouldValidate: true }
    );

    setValue(
      "paymentModeType",
      {
        value: chequeData?.modeOfPayment?.toLowerCase(),
        label: paymentModeOptions.find(
          (option) =>
            formatString(option.value)?.toLowerCase() === formatString(chequeData?.modeOfPayment)?.toLowerCase()
        )?.label,
      },
      { shouldValidate: true }
    );

    setValue(
      "bouncedChequePaymentMode",
      {
        value: orgData?.bouncedChequeFee?.mode?.toLowerCase(),
        label: paymentModeOptions.find(
          (option) =>
            formatString(option.value)?.toLowerCase() === formatString(orgData?.bouncedChequeFee?.mode)?.toLowerCase()
        )?.label,
      },
      { shouldValidate: true }
    );

    setPaymentMode(chequeData?.modeOfPayment?.toLowerCase());
    setValue("paymentRef", chequeData?.documentNo, { shouldValidate: false });
    setValue("bouncedChequeFee", bouncedChequeFee, { shouldValidate: false });

    if (chequeData?.bankName) {
      const bank = formatString(chequeData.bankName)?.toLowerCase();
      setValue("bankName", { value: bank, label: bank }, { shouldValidate: false });
      setBankNameFromDropDown(bank);
    }

    if (chequeData?.subPdcs?.length > 0) {
      let partialPaidCheque = data?.params?.data?.subPdcs?.filter(
        (item) => item?.status?.toLowerCase() === "paid" && item?.paymentMode?.toLowerCase() === "cheque"
      );
      const lastSubPdc = partialPaidCheque[partialPaidCheque.length - 1];
      setValue("subPdcRef", { value: lastSubPdc?.subPdcId, label: lastSubPdc?.documentNo }, { shouldValidate: false });
    }

    setValue("paymentRefReplaced", chequeData?.documentNo);
    setValue("invoicePeriod", rangePickerInitialValue(data, "invice_period"));
    // --- Step 3: Handle reason field
    const reasonOption = bouncedReasons.find((opt) => opt.value === chequeData?.reason) || bouncedReasons[0];

    setValue("reason", { value: reasonOption?.value, label: reasonOption?.label }, { shouldValidate: false });
  }, [data, onEditBack]);
};
